import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-2 font-mono-accent text-[11px] tracking-widest uppercase text-[#0A1A4A]/50" data-testid="breadcrumbs">
    {items.map((it, i) => (
      <span key={`${it.path}-${i}`} className="flex items-center gap-2">
        {i > 0 && <ChevronRight size={12} />}
        {i < items.length - 1 ? (
          <Link to={it.path} className="hover:text-[#2563EB] transition-colors">{it.name}</Link>
        ) : (
          <span className="text-[#2563EB]">{it.name}</span>
        )}
      </span>
    ))}
  </nav>
);
